import { Route, Routes } from "react-router-dom";

import { Changelog } from "./pages/Changelog";
import { History } from "./pages/History";
import { Home } from "./pages/Home";
import { Uptime } from "./pages/Uptime";

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/history" element={<History />} />
      <Route path="/uptime" element={<Uptime />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route
        path="*"
        element={
          <main className="mx-auto max-w-4xl px-6 py-12 text-text-muted">
            Page not found.
          </main>
        }
      />
    </Routes>
  );
}
